import { createFileRoute } from '@tanstack/react-router';
import { zOrgType, zPaymentStatus, zSortDirection } from 'client/zod.gen';
import { zFiltersArray } from 'helpers/router';
import { z } from 'zod';

export const companiesSchema = z.object({
  payment_status: zFiltersArray(zPaymentStatus),
  sort: z
    .union([
      z.literal('type'),
      z.literal('payment_status'),
      z.literal('name'),
      z.literal('teams_count'),
      z.literal('users_count'),
    ])
    .optional()
    .catch('name')
    .default('name'),
  order: zSortDirection.optional().catch('asc').default('asc'),
  type: zFiltersArray(zOrgType),
});

export const Route = createFileRoute('/_private/_route/_internal/companies/')({
  validateSearch: companiesSchema,
});
